import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import EnquiryForm from "../shared/enquiryForm/enquiryForm";
import CustomButton from "../shared/button/button";
import "./download.css";
/**
 * @author
 * @function DownloadBrochure
 *
 * Two modes, decided purely by whether `brochureUrl` is passed in:
 *
 * 1. brochureUrl provided (currently only Gowri Anandham) → clicking the
 *    button downloads that PDF immediately. No modal, no form, no lead
 *    capture — a plain, direct file download.
 * 2. brochureUrl omitted (Kanchipuram, Padappai, Sholavaram, Sangamam)
 *    → unchanged: opens the modal with the EnquiryForm lead-capture form.
 **/

export const DownloadBrochure = ({ brochureUrl }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);

  const triggerDirectDownload = () => {
    const link = document.createElement("a");
    link.href = brochureUrl;
    link.download = "Anandham-Plots-Brochure.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleButtonClick = () => {
    if (brochureUrl) {
      triggerDirectDownload();
    } else {
      setShow(true);
    }
  };

  return (
    <div className="download-brochure">
      <CustomButton
        title="Download Brochure"
        textcolor="green"
        btnBg="light"
        textWeight={700}
        btnMinWidth="8rem"
        btnBorderRadius="5px"
        handleClick={handleButtonClick}
      />

      {!brochureUrl && (
        <Modal
          show={show}
          size="lg"
          style={{ background: "transparent" }}
          onHide={handleClose}
        >
          <Modal.Header closeButton>
            {/* <Modal.Title className='green-text'><b>Download Broucher Form</b></Modal.Title> */}
          </Modal.Header>
          <Modal.Body>
            <EnquiryForm
              source="Brochure Download Form"
              onSuccess={handleClose}
            />
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
};
